/* eslint-disable formatjs/no-literal-string-in-jsx */
import { FC } from 'react';
import { z } from 'zod';
import { useDrawerContext } from './DrawerContext';
import { Stack } from '@mui/material';

const testDrawerSchema = z.object({
	id: z.string(),
	name: z.string(),
});

const TestDrawer: FC<z.infer<typeof testDrawerSchema>> = ({ id, name }) => {
	const { closeDrawer } = useDrawerContext();

	return (
		<Stack>
			{id} {name}
			<button onClick={() => closeDrawer()}>zavrit</button>
		</Stack>
	);
};

export { TestDrawer, testDrawerSchema };
